import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Divider } from './Divider';
import { applyTransparency } from '../../constants/colors';
import { PopupV2 } from './PopupV2';
import { isMobile } from '@mightybyte/rnw.utils.device-info';
import ButtonGeneral from './ButtonGeneral';
import Warning from 'react-native-vector-icons/FontAwesome';
import Trash from 'react-native-vector-icons/FontAwesome';

interface IPopupProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  onRemovePress: () => void;
  firstName: string;
  lastName: string;
  loading: boolean;
}
const RemovePopup = ({
  visible,
  setVisible,
  onRemovePress,
  firstName,
  lastName,
  loading,
}: IPopupProps) => {
  return (
    <PopupV2
      height={isMobile ? 440 : 'auto'}
      title="Delete Student"
      visible={visible}
      setVisible={setVisible}
      closeOnBackdropPress={true}
      containerStyle={{ backgroundColor: '#FCEABB', borderColor: '#FFCF53' }}
      icon={<Trash name="trash" size={22} color="#ffffff" />}
      headerTextStyle={{ fontSize: isMobile ? 18 : 24 }}
      hideCloseButton={true}
    >
      <View style={styles.container}>
        <Divider empty height={68} />
        <View style={[styles.textContainer]}>
          <Text style={styles.title}>
            Are you sure you want to delete “{firstName} {lastName}”?
          </Text>
          <Text style={styles.subtitle}>
            This action will permanently remove all data for this student, including progress,
            scores, and history.
          </Text>
        </View>
        <View style={[styles.undoneWarningContainer]}>
          <Warning name="warning" size={14} color="#FFA614" />
          <Text style={{ marginLeft: 6 }}>This cannot be undone.</Text>
        </View>

        <View style={[styles.buttonContainer, { height: isMobile ? 80 : 102 }]}>
          <View style={{ marginRight: isMobile ? 8 : 12 }}>
            <ButtonGeneral
              onPress={() => {
                setVisible(false);
              }}
              title={'Cancel'}
              height={isMobile ? 48 : 58}
              width={isMobile ? 151 : 201}
              fontSize={isMobile ? 14 : 16}
              fontStyle={{ color: '#ffffff' }}
              colors={['#FFCF53', '#FF9900']}
            />
          </View>
          <ButtonGeneral
            onPress={onRemovePress}
            title={'Delete'}
            height={isMobile ? 48 : 58}
            width={isMobile ? 151 : 201}
            fontSize={isMobile ? 14 : 16}
            fontStyle={{ color: '#FF3F15' }}
            colors={['#FEDD88', '#FEDD88']}
            nameContainerStyle={{
              borderColor: '#FF3F15',
              borderWidth: 2,
              marginRight: isMobile ? 10 : 0,
            }}
          />
        </View>
      </View>
    </PopupV2>
  );
};

export { RemovePopup };

const styles = StyleSheet.create({
  textContainer: {
    paddingHorizontal: 59,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    textAlign: 'center',
    fontFamily: 'Secular One',
    fontWeight: '400',
    color: '#121212',
    fontSize: 24,
    marginBottom: 12,
  },
  subtitle: {
    fontWeight: '600',
    color: '#453B3B',
    fontSize: 16,
    marginBottom: 29,
    textAlign: 'center',
  },
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 395,
  },
  buttonTextStyle: {
    fontFamily: 'Secular One',
    color: '#fff',
    fontSize: 20,
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
  },
  buttonContainer: {
    justifyContent: 'center',
    backgroundColor: '#FEDD88',
    alignItems: 'center',
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    flexDirection: 'row',
    width: '100%',
    marginTop: 20,
  },
  undoneWarningContainer: {
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 12,
    marginTop: 12,
    backgroundColor: '#FEDD88',
    flexDirection: 'row',
    alignItems: 'center',
  },
});
